module.exports = __webpack_public_path__ + "img/discount_tips_bg.33340167.jpg";